$(document).ready(function () {
    // #region Login/Register Page
    $(document).on("submit", "form.LoginRegisterForm", function () {
        form = $(this);
        GenerateLocalLoading(form, "show");

        UserForms(form, function (dt) {
            if (dt.Sonuc == true) {
                if (dt.JsonRs == "Reload") {
                    document.location.reload();
                }
                else if (dt.JsonRs == "Redirect") {
                    document.location = dt.Deger5;
                }
                else if (dt.JsonRs == "ChangePass") {
                    GenerateLocalLoading(form, "hide");

                    var loginUrl = getRequestRoute() + "/p/User/Login";

                    //SwalGenerate("success", dt.IslemSonucAciklama, getStandartMessages("IslemBasarili"), "<a href='" + loginUrl + "'>" + getStandartMessages("GirisYap") + "</a>");

                    SwalGenerate("success", dt.IslemSonucAciklama, getStandartMessages("IslemBasarili"), "<a href='" + loginUrl + "' id='OpenMenuTrigger'>" + dt.Deger5 + "</a>");
                }
                else if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                    document.location = $("#register_FbRedirectUrl").val();
                }
                else {
                    GenerateLocalLoading(form, "hide");
                    var fireObject = SwalGenerate("success", dt.IslemSonucAciklama, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));

                    if (dt.JsonRs == "ConfirmMail") {
                        fireObject.then(function (result) {
                            document.location = "/" + $("#SmallLangCode").val();
                        });
                    }
                }
            }
            else {
                var errorMsg = dt.IslemSonucAciklama;

                if (errorMsg == "" || errorMsg == null) {
                    errorMsg = dt;
                }
                if (dt.ResultCode == 406) {
                    SwalGenerate("error", errorMsg, getStandartMessages("YenidenHosgeldiniz"), getStandartMessages("SifremiYenile"));
                }
                else {
                    SwalGenerate("error", errorMsg, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }

                GenerateLocalLoading(form, "hide");
            }

            grecaptchaEvent(form.find("[data-reCaptcha]"), "reset");
        });

        return false;
    });

    $(document).on("click", ".js-forgot-password", function (e) {
        GetForgottenPasswordForm(function (status, data) {
            if (status) {
                $("#forgottenpassModal .js-forgotten-password-content").html(data);
                
                recaptchaCallback();

                $("#forgottenpassModal").modal('show');
            }
            else {
                SwalGenerate("error", data, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        });
    });

    $(document).on("submit", "form.ForgettenForm", function () {
        form = $(this);
        GenerateLocalLoading(form, "show");

        UserForms(form, function (dt) {
            if (dt.Sonuc == true) {
                $("#forgottenpassModal").modal('hide');
                SwalGenerate("success", dt.IslemSonucAciklama, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
            }
            else {
                var errorMsg = dt.IslemSonucAciklama;

                if (errorMsg == "" || errorMsg == null) {
                    errorMsg = dt;
                }

                SwalGenerate("error", errorMsg, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }

            grecaptchaEvent(form.find("[data-reCaptcha]"), "reset");

            GenerateLocalLoading(form, "hide");
        });

        return false;
    });

    //ModalHideEvent($('#forgottenpassModal'), ".js-forgotten-password-content");

    $(document).on("click", "#SingOut", function () {
        if (!isAppleMobile()) {
            localStorage.removeItem("LastVisitedPrds");
        }
    });
    // #endregion Login/Register Page

    // #region MyAcount
    $(document).on("submit", "form.UserInfoForm, form.ChangePassForm, form.AdresForm", function () {
        form = $(this);
        GenerateLocalLoading(form, "show");

        AccountAjaxForms(form, function (status, message) {
            if (status == true) {
                if (form.hasClass("AdresForm")) {
                    $("#AddressAddModal").modal("hide");
                    GetAddressList();
                }

                SwalGenerate("success", message, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
            }
            else {
                SwalGenerate("error", message, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }

            GenerateLocalLoading(form, "hide");
        });

        return false;
    });

    //SavedCards
    $(document).on("click", ".DeleteSavedCard", function () {

        var ctoken = $(this).attr("data-ctoken");

        if (ctoken != undefined && ctoken != "") {

            RemoveElement = $(this).parents(".UserCardItem");

            GenerateLocalLoading(RemoveElement, "show");

            DeleteSavedCard(ctoken, function (status, message) {
                if (status) {
                    RemoveElement.remove();
                } else {
                    SwalGenerate("error", message, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                    GenerateLocalLoading(RemoveElement, "hide");
                }
            });
        }

    });


    // FollowList
    $(document).on("click", ".FollowList .FollowListItems .DeleteFollowItem", function () {
        var id = $(this).attr("data-id");
        var LangID = $("#LangID").val();
        RemoveElement = $(this).parents(".FollowListItems");

        GenerateLocalLoading(RemoveElement, "show");

        DeleteFollowItem(id, LangID, function (status, message) {
            if (status) {
                RemoveElement.remove();
            }
            else {
                SwalGenerate("error", message, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                GenerateLocalLoading(RemoveElement, "hide");
            }
        });
    });

    // #region Orders
    $(document).on("click", "#UserOrderModal .cargoTrackButton", function () {
        Modal = $("#CargoTrackModal");
        var trackPage = $(this).attr("data-url");

        if (trackPage != null && trackPage != "" && trackPage != undefined) {
            iframe = Modal.find(".modal-body .CargoTrackPage");
            iframe.attr("src", trackPage);
            iframe.css("width", "100%");
            iframe.css("height", $(window).height() - 200);

            Modal.modal("show");
        }
    });

    $(document).on("click", "#UserOrderModal .MoneyTransferInfo", function () {
        var trackCode = $(this).attr("data-trackCode");

        if (trackCode != null && trackCode != "" && trackCode != undefined) {
            GenerateLocalLoading(Modal.find(".MoneyTransferContainer"), "show");

            GetMoneyTransferInfoForm(trackCode, function (status, data) {
                if (status) {
                    Modal.find(".MoneyTransferContainer").html(data);
                }
                else {
                    SwalGenerate("error", data, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }

                GenerateLocalLoading(Modal.find(".MoneyTransferContainer"), "hide");
            });
        }
    });

    $(document).on("submit", "#UserOrderModal .MoneyTransferContainer .MoneyTransferForm", function () {
        form = $(this);

        GenerateLocalLoading(form, "show");

        AccountAjaxForms(form, function (status, message) {
            if (status == true) {
                SwalGenerate("success", message, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));

                form.closest(".MoneyTransferContainer").html("");
            }
            else {
                SwalGenerate("error", message, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }

            GenerateLocalLoading(form, "hide");
        });

        return false;
    });

    // #region ReturnProduct
    $(document).on("click", "#UserOrderModal .MyOrderList .MyOrderListItem .productOperations .ReturnProduct", function () {
        var orderedItemsID = $(this).attr("data-id");
        ItemRow = $(this).closest("tr");

        if (orderedItemsID != null && orderedItemsID != "" && orderedItemsID != undefined && orderedItemsID > 0) {
            GenerateLocalLoading(ItemRow, "show");

            GetRetOrdersForm(orderedItemsID, function (status, data) {
                if (status) {
                    GenerateLocalLoading(ItemRow, "hide");
                    ItemRow.find(".ReturnProductReason").html(data);
                }
                else {
                    SwalGenerate("error", data, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                    GenerateLocalLoading(ItemRow, "hide");
                }
            });
        }
    });

    $(document).on("submit", "#UserOrderModal .MyOrderList .MyOrderListItem .productOperations .ReturnProductReason .RetOrderForm", function () {
        form = $(this);
        ItemRow = $(this).closest("tr");
        GenerateLocalLoading(ItemRow, "show");

        AccountAjaxForms(form, function (status, message) {
            GenerateLocalLoading(ItemRow, "hide");

            if (status) {
                GenerateLocalLoading(ItemRow.closest(".modal-content"), "show");

                GetUserOrderDetails($orderDetailModalUrl, function (data) {
                    Modal.find(".modal-content").html(data);

                    SwalGenerate("success", message, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
                    GenerateLocalLoading(ItemRow.closest(".modal-content"), "hide");
                });
            }
            else {
                SwalGenerate("error", message, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }

        });

        return false;
    });

    $(document).on("click", "#UserOrderModal .MyOrderList .MyOrderListItem .productOperations .ReturnProductReason .btn.cancel", function () {
        ItemRow = $(this).closest("tr");
        ItemRow.find(".ReturnProductReason").html("");
    });
    // #endregion

    // #endregion

    // #region Address
    $(document).on("click", ".js-new-address", function () {
        AddressModal = $("#AddressAddModal");

        AddressModal.modal("show");
        ModalHideEvent(AddressModal, ".modal-body");

        GenerateLocalLoading(AddressModal.find(".modal-dialog"), "show");

        GetPartialAdress(AddressModal);
    });

    $(document).on("click", ".js-address-edit", function () {
        AddressModal = $("#AddressAddModal");
        var id = $(this).attr("data-id");

        if (id != undefined && id != "" && id > 0) {
            AddressModal.modal("show");
            ModalHideEvent(AddressModal, ".modal-body");
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "show");

            var EditUrl = getRequestRoute() + "/p/User/AdressEdit/" + id;

            GetPartialAdress(AddressModal, EditUrl);
        }
        else {
            SwalGenerate("error", getStandartMessages("IslemBasarisiz"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        }
    });

    $(document).on("click", ".js-address-delete", function () {
        var id = $(this).attr("data-id");
        var AddressContainer = $(this).parents(".AddressContainer");

        if (id != undefined && id != "" && id > 0) {
            DeleteAddress(id, AddressContainer);
        }
        else {
            SwalGenerate("error", getStandartMessages("IslemBasarisiz"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        }
    });

    $(document).on("click", "#AddressAddModal .FormButtons .btn-cancel", function () {
        $("#AddressAddModal").modal("hide");
    });

    $(document).on("change", "#AddressAddModal .ddl_sehir", function () {
        AddressModal = $("#AddressAddModal");
        var seciliSehirOID = $(this).val();

        if (seciliSehirOID != undefined && seciliSehirOID != "") {
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "show");

            GetDistrict(seciliSehirOID);
        }
        else {
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
            $('#TownID option:gt(0)').remove();
        }
    });
    // #endregion Address

    // #region Messages
    $(document).on("click", ".UserMessage .UserMessageList #UserMessages tbody tr, .UserMessage .NewItemPlus .NewMessageButton", function () {
        var id = $(this).attr("data-id");

        if (id != null && id != "" && id != undefined) {
            var url = getRequestRoute() + "/p/User/MessageDetail?id=" + id;

            GetMessageDetail(url);

            if ($(this).hasClass("UnreadMessage")) {
                $(this).removeClass("UnreadMessage");
            }
        }
    });

    $(document).on("submit", "form.UserMessageForm", function () {
        form = $(this);
        GenerateLocalLoading(form, "show");

        var IsNewMessage = false;
        var MessageID = $(".AddMessageContainer #UserMessageID").val();
        if (MessageID == null || MessageID == undefined || MessageID == "" || MessageID <= 0) {
            IsNewMessage = true;
        }

        AddNewUserMessage(form, function (data, sonuc) {
            if (sonuc == false) {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                GenerateLocalLoading(form, "hide");
            }
            else {
                GenerateLocalLoading(form, "hide");

                if (data.Sonuc == true) {
                    SwalGenerate("success", getStandartMessages("MesajinizIletildi"), "", getStandartMessages("Kapat"));
                    $("#MessageDetailModal").modal("hide");

                    if (IsNewMessage) {
                        GenerateLocalLoading($("#UserMessages"), "show");

                        $.ajax({
                            url: getRequestRoute() + "/p/User/Messages",
                            type: "GET",
                            cache: false,
                            success: function (data) {
                                $("#UserMessages tbody").html(data);
                                GenerateLocalLoading($("#UserMessages"), "hide");
                            },
                            error: function () {
                                GenerateLocalLoading($("#UserMessages"), "hide");
                            }
                        });
                    }
                }
                else {
                    SwalGenerate("error", data.IslemSonucAciklama, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }
            }
        });

        return false;
    });
    // #endregion
    // #endregion MyAcount

    $('.ToggleAccountMenu').click(function () {
        $(".AccountMenu").toggleClass("open");
    });

    $(document).on("submit", "form.ContactForm", function (e) {
        form = $(this);
        GenerateLocalLoading(form, "show");

        AccountAjaxForms(form, function (status, message) {
            $(".ContactForm #Subject").val("");
            $(".ContactForm #Message").val("");

            if (status) {
                SwalGenerate("success", message, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
            }
            else {
                SwalGenerate("error", message, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }

            GenerateLocalLoading(form, "hide");
        });

        e.preventDefault();
        return false;
    });

    $(document).on("submit", "form.MyOrderNotMember", function (e) {
        form = $(this);
        GenerateLocalLoading(form, "show");

        MyOrderNotMember(form);

        e.preventDefault();
        return false;
    });

    SetCurrentMenuItem();
    PhoneFormatAccount();
    ValidationForm();

    if (isMobileResolution()) {
        AccountMobileSetting();
        ContentMobileSetting();
    }
});

function AccountMobileSetting() {
    if ($("body.user .UserPage").length > 0 || $("body.orders .UserPage").length > 0) {
        var activeText = $(".UserPage  .AccountLeft .LeftMenuBody .mobile-dropdown .dropdown-menu .dropdown-item.active").html();
        $(".UserPage  .AccountLeft .LeftMenuBody .mobile-dropdown .btn").html(activeText);

        if ($(".UserPage  .AccountRight .PageBodyContainer .MyAddress").length > 0) {
            $(".UserPage  .AccountRight .PageBodyContainer .MyAddress .AdressListTable tfoot td").first().remove();
            $(".UserPage  .AccountRight .PageBodyContainer .MyAddress .AdressListTable tfoot td").attr("colspan", "3");
        }
    }
}

function ContentMobileSetting() {
    if ($("body.contentpg .ContentPage").length > 0) {
        var activeText = $(".ContentPage  .ContentLeft .LeftMenuBody .ul li.menuitem.active a span").html();
        $(".UserPage  .ContentLeft .LeftMenuBody .mobile-dropdown .btn").html(activeText);
    }
}

function ValidationForm() {
    if ($("form.LoginRegisterForm.LoginForm").length > 0) {
        var emailRequired = $(".LoginRegisterForm #login_UserName").attr("data-required");
        var emailValid = $(".LoginRegisterForm #login_UserName").attr("data-valid");
        var passRequired = $(".LoginRegisterForm #login_Password").attr("data-required");

        $("form.LoginRegisterForm.LoginForm").validate({
            rules: {
                "login.UserName": {
                    required: true,
                    email: true
                },
                "login.Password": "required"
            },
            messages: {
                "login.UserName": {
                    required: emailRequired,
                    email: emailValid
                },
                "login.Password": {
                    required: passRequired
                }
            }
        });
    }

    if ($("form.LoginRegisterForm.RegisterForm").length > 0) {
        var emailRequired = $(".LoginRegisterForm #register_UserName").attr("data-required");
        var emailValid = $(".LoginRegisterForm #register_UserName").attr("data-valid");
        var nameRequired = $(".LoginRegisterForm #register_Name").attr("data-required");
        var GsmRequired = $(".LoginRegisterForm #register_Gsm").attr("data-required");
        var GsmValid = $(".LoginRegisterForm #register_Gsm").attr("data-valid");
        var birthdayRequired = $(".LoginRegisterForm #register_BirthDate").attr("data-required");
        var passRequired = $(".LoginRegisterForm #register_Password").attr("data-required");
        var passAgainRequired = $(".LoginRegisterForm #register_ConfirmPassword").attr("data-required");

        var countryCode = getCookie("Service_GeoLocation:SelectedCountryCode:");

        var gsmLength = 14;

        if (countryCode != "TR") {
            gsmLength = 3;
        }

        $("form.LoginRegisterForm.RegisterForm").validate({
            rules: {
                "register.UserName": {
                    required: true,
                    email: true
                },
                "register.Name": {
                    required: true
                },
                "register.Gsm": {
                    required: true,
                    minlength: gsmLength
                },
                "register.BirthDate": "required",
                "register.Password": {
                    required: true,
                    minlength: 6
                },
                "register.ConfirmPassword": "required"
            },
            messages: {
                "register.UserName": {
                    required: emailRequired,
                    email: emailValid
                },
                "register.Name": {
                    required: nameRequired
                },
                "register.Gsm": {
                    required: GsmRequired,
                    minlength: GsmValid
                },
                "register.BirthDate": {
                    required: birthdayRequired
                },
                "register.Password": {
                    required: passRequired,
                    minlength: passRequired
                },
                "register.ConfirmPassword": {
                    required: passAgainRequired
                }
            }
        });
    }

    if ($("form.LoginRegisterForm.ForgettenPassForm").length > 0) {
        var emailRequired = $(".ForgettenPassForm #email").attr("data-required");
        var emailValid = $(".ForgettenPassForm #email").attr("data-valid");

        $("form.LoginRegisterForm.ForgettenPassForm").validate({
            rules: {
                "email": {
                    required: true,
                    email: true
                }
            },
            messages: {
                "email": {
                    required: emailRequired,
                    email: emailValid
                }
            }
        });
    }

    if ($("form.LoginRegisterForm.ResetPassForm").length > 0) {
        var passRequired = $(".ResetPassForm #NewPassword").attr("data-required");
        var passValid = $(".ResetPassForm #NewPassword").attr("data-valid");
        var passConfirmRequired = $(".ResetPassForm #ConfirmPassword").attr("data-required");
        var passConfirmValid = $(".ResetPassForm #ConfirmPassword").attr("data-valid");

        $("form.LoginRegisterForm.ResetPassForm").validate({
            rules: {
                "NewPassword": {
                    required: true,
                    minlength: 6
                },
                "ConfirmPassword": {
                    required: true,
                    minlength: 6
                }
            },
            messages: {
                "NewPassword": {
                    required: passRequired,
                    minlength: passValid
                },
                "ConfirmPassword": {
                    required: passConfirmRequired,
                    minlength: passConfirmValid
                }
            }
        });
    }
}

function PhoneFormatAccount() {
    var countryCode = getCookie("Service_GeoLocation:SelectedCountryCode:");

    if (countryCode == "TR") {
        $("#register_Gsm").mask("9999 999 99 99", {
            translation: {
                'Z': {
                    pattern: /[0-9]/, optional: true
                }
            }
        });

        $("#localPassVM_User_Gsm").mask("9999 999 99 99", {
            translation: {
                'Z': {
                    pattern: /[0-9]/, optional: true
                }
            }
        });

        $("#Phone2").mask("999 999 99 99", {
            translation: {
                'Z': {
                    pattern: /[0-9]/, optional: true
                }
            }
        });

        $(document).on("keyup", "#Phone2", function () {
            var phone = $(this).val();
            var firstChar = phone.substr(0, 1);

            if (firstChar == "0") {
                phone = phone.substr(1, phone.length);
                $(this).val(phone);
            }
        });

        $(".contact-form #Phone").mask("999 999 99 99", {
            translation: {
                'Z': {
                    pattern: /[0-9]/, optional: true
                }
            }
        });
    }
    else if (countryCode == "RU") {
        $("#register_Gsm").mask("99999999999", {
            translation: {
                'Z': {
                    pattern: /[0-9]/, optional: true
                }
            }
        });

        $("#localPassVM_User_Gsm").mask("99999999999", {
            translation: {
                'Z': {
                    pattern: /[0-9]/, optional: true
                }
            }
        });

        $("#Phone2").mask("99999999999", {
            translation: {
                'Z': {
                    pattern: /[0-9]/, optional: true
                }
            }
        });

        $(".contact-form #Phone").mask("99999999999", {
            translation: {
                'Z': {
                    pattern: /[0-9]/, optional: true
                }
            }
        });
    }
}

function SetCurrentMenuItem() {
    if (document.URL.indexOf("/p/User/") > -1 || document.URL.indexOf("/p/Orders/") > -1) {
        $(".grey .menuitem a").each(function (index) {
            var CurUrl = document.URL.split('/p/User/')[1];
            var CurLink = "";

            if (document.URL.indexOf("/p/Orders/") > -1) {
                CurUrl = document.URL.split('/p/Orders/')[1];
                CurLink = getRequestRoute() + "/p/Orders/" + $("#AName").val();
            }
            else {
                CurLink = getRequestRoute() + "/p/User/" + $("#AName").val();
            }

            if ($(this).attr("href").indexOf(CurLink) > 0) {

                if ($(this).attr("href").indexOf("hb=t") < 0) {
                    $(this).closest("li").addClass("current");

                }
                else if ($(this).attr("href").indexOf("hb=t") > 0 && document.URL.indexOf("hb=t") > -1) {
                    $(".grey li").removeClass("current");
                    $(this).closest("li").addClass("current");
                }
            }
        });

        $(".ToggleAccountMenu").html($(".menuitem.current:first").text() + "<span></span>");

        if ($(".menuitem.current:first").length <= 0) {
            $(".ToggleAccountMenu").html($(".menuitem:first").text() + "<span></span>");
        }
    }
}

function FollowListOptions() {
    //LazyLoad();

    $(".js-add-favorites").addClass("is-followlist").addClass("active");

    $(document).on("click", ".js-add-favorites.active", function () {
        var ProductID = $($(this)).attr("data-id");
        var element = $(this).closest(".Prd");
        GenerateLocalLoading(element, "show");

        removeFavorite(ProductID, function (result) {
            if (result == true) {
                element.remove();
            }
            else {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
            }

            GenerateLocalLoading(element, "hide");
        });
    });
}